module.exports = __webpack_public_path__ + "img/clear.6a4621db.png";